import { useState } from 'react';
import { api } from '../lib/api';
import { haptic } from '../lib/telegram';
import { CoinIcon, CrystalIcon, TicketIcon } from '../components/Currency';

/**
 * Раздел 4.1. Три экрана и согласие. Без галки внутрь не пускаем —
 * это юридически обязательный элемент, а не формальность (раздел 14).
 */

const SLIDES = [
  {
    icon: <TicketIcon size={44} />,
    title: 'Крути колесо каждый день',
    text: 'Прокруты дают задания, друзья и ежедневный вход. Пустых секторов нет: что-то выпадает всегда.',
  },
  {
    icon: <CoinIcon size={44} />,
    title: 'Копи коины — попадай в розыгрыш',
    text: 'Коины меняются на билеты. Чем больше билетов на приз, тем выше шанс. Победителей выбираем вживую на стриме.',
  },
  {
    icon: <CrystalIcon size={44} />,
    title: 'Пройди курс — получишь больше всех',
    text: 'Курс даёт больше коинов, чем всё остальное вместе. А кристаллы с него остаются навсегда и тратятся в магазине.',
  },
];

export function Onboarding({ onDone }: { onDone: () => Promise<void> }) {
  const [step, setStep] = useState(0);
  const [agreed, setAgreed] = useState(false);
  const [busy, setBusy] = useState(false);
  const last = step === SLIDES.length;

  async function accept() {
    setBusy(true);
    try {
      await api.post('/me/accept-terms');
      haptic.ok();
      await onDone();
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="relative z-10 mx-auto flex min-h-full max-w-md flex-col px-6 pb-10 pt-[max(48px,env(safe-area-inset-top))]">
      <div className="mb-8 flex gap-1.5">
        {[...SLIDES, null].map((_, i) => (
          <span key={i} className={`h-1 flex-1 rounded-full ${i <= step ? 'bg-gold' : 'bg-line'}`} />
        ))}
      </div>

      {!last ? (
        <div key={step} className="rise flex flex-1 flex-col justify-center">
          <div className="mb-6">{SLIDES[step].icon}</div>
          <h1 className="mb-3 font-display text-2xl leading-tight">{SLIDES[step].title}</h1>
          <p className="text-[15px] leading-relaxed text-ash">{SLIDES[step].text}</p>
        </div>
      ) : (
        <div className="rise flex flex-1 flex-col justify-center">
          <h1 className="mb-3 font-display text-2xl leading-tight">Последний шаг</h1>
          <p className="mb-6 text-[15px] leading-relaxed text-ash">
            Участие бесплатное. Коины и прокруты нельзя купить за деньги — ни сейчас, ни потом.
          </p>
          <label className="flex cursor-pointer items-start gap-3 rounded-2xl border border-line bg-surface p-4">
            <input
              type="checkbox" checked={agreed} onChange={(e) => setAgreed(e.target.checked)}
              className="mt-0.5 h-5 w-5 shrink-0 accent-[var(--gold)]"
            />
            <span className="text-sm leading-relaxed">
              Мне есть 18 лет, я согласен с{' '}
              <a href={import.meta.env.VITE_RULES_URL ?? '#'} target="_blank" rel="noreferrer"
                 className="text-turq underline">правилами акции</a>{' '}и{' '}
              <a href={import.meta.env.VITE_PRIVACY_URL ?? '#'} target="_blank" rel="noreferrer"
                 className="text-turq underline">обработкой персональных данных</a>.
            </span>
          </label>
        </div>
      )}

      <div className="mt-8">
        {!last ? (
          <button className="btn-primary w-full" onClick={() => { haptic.tap(); setStep(step + 1); }}>
            Дальше
          </button>
        ) : (
          <button className="btn-primary w-full" disabled={!agreed || busy} onClick={accept}>
            {busy ? 'Открываем…' : 'Начать и забрать 20 коинов'}
          </button>
        )}
        {!last && (
          <button className="mt-2 w-full py-2 text-sm text-ash" onClick={() => setStep(SLIDES.length)}>
            Пропустить
          </button>
        )}
      </div>
    </div>
  );
}
